<template>
  <div class="order-wrapper payment-wrapper" :class="{ 'is-active': openSlideleft }">
    <portal target-el="#filter">
      <primary-filter
        :menuOptions="$checkMenuOptions(historicIndentsMenu)"
        :selectedCategory="selectedCategory"
        :enableSearchPopup="true"
        :searchParameters="searchParameters"
        :preSearchedParams="searchedParams"
        @searchByParameter="searchByParameter" />
    </portal>
    <div>
      <div class="flex-container page-filter">
        <div class="flex-item">
          <filter-wrapper
            :values="filterTags"
            @openSliderLeft="openSlideleft = !openSlideleft"/>
        </div>
      </div>
      <div class="slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
        <div class="slideleft_content">
          <div class="content">
            <div
              v-infinite-scroll="loadData"
              infinite-scroll-disabled="loadCheck"
              infinite-scroll-throttle-delay="400"
              infinite-scroll-distance="10">
              <indent-header
                :headers="indentsHeader"
                :noCheckbox="true" />
              <div v-if="isLoading" class="paymentloader"></div>
              <div v-else-if="indents.length === 0" class="emptydiv">
                <div class="paymentempty"></div>
                <div class="emptytext">{{$t('INDENTS_NO_INDENTS_FOUND')}}</div>
              </div>
              <div v-else>
                <indents-row v-for="(indent,index) in indents"
                             :key="index"
                             :sectionHeader="indentsHeader"
                             :indent="indent"
                             :depot_id="currentDepotId"
                             :isFilterClosed="!openSlideleft"
                             :configurations="configurations"
                             @show-details="showDetails"
                             @accept-indent="acceptIndent(indent.order_no)"
                             @show-actions="showActions"
                             @setGA="setGA" />
                <div v-if="isPaginating">
                  <Spinner />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slideleft_menu">
          <sec-filter
            v-if="filterConstant.length"
            :selectedFilters="filterConstant"
            @search="search"
            @updateOption="updateOption"
            @reset="resetApply"
            @clearDate="clearDate" />
        </div>
        <div>
          <drawer
            :visible.sync="isDetailsEnabled"
            direction="rtl"
            size="750px"
            :modal="true"
            :withHeader="false"
            :append-to-body="true"
            class="default-drawer">
            <Link :underline="false" class="nav-close" @click="isDetailsEnabled=false">
              <svgicon name="cancelwhite" width="12" height="12" :original="true" />
            </Link>
            <indents-actions
              v-if="isDetailsEnabled"
              :indent="selectedIndent"
              :activeTab="activeTab"
              :action="action"
              @rejectIndent="rejectIndent"
              @cancelAction="closeSlider"
              @updateTruck="updateTruck"
              @updateTruckType="updateTruckType"
              @updateLR="updateLR"
              @markDeliver="markDeliver"
              @updateHillyRegion="updateHillyRegion"
              @truck-in="truckIn"
              @truck-out="truckOut"
              @containerPickup="containerPickup" />
          </drawer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  historicIndentsMenu,
  searchParameters,
  filters,
  indentsStatus,
  indentsHeader } from '@/constants/indentConstants';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import FilterWrapper from '@common/components/FilterWrapperV2';
import IndentHeader from '@common/components/HeaderV2';
import PrimaryFilter from '@/modules/common/PrimaryFilter';
import IndentsRow from '@/modules/indents/components/indentsRow';
import IndentsActions from '@/modules/indents/components/details/indentsActions';

export default {
  components: {
    IndentHeader,
    SecFilter,
    FilterWrapper,
    PrimaryFilter,
    IndentsRow,
    IndentsActions,
  },
  data() {
    return {
      historicIndentsMenu,
      searchParameters,
      filters,
      indentsStatus,
      indentsHeader,
      openSlideleft: false,
      defaultValues: {},
      filterConstant: [],
      loadCheck: true,
      searchedParams: {},
      isDetailsEnabled: false,
      selectedIndent: null,
      activeTab: '',
      currentDepotId: '',
      action: '',
      indentStatusList: [],
      includeDeliverStatus: true,
    };
  },
  mixins: [SecFilterMixin],
  computed: {
    ...mapGetters({
      depots: 'app/depots',
      indents: 'indents/list',
      filter: 'indents/filter',
      hasEmpty: 'indents/hasEmpty',
      isLoading: 'indents/isLoading',
      isPaginating: 'indents/isPaginating',
      configurations: 'app/currentClientConfig',
      parentList: 'indents/parentList',
    }),
    selectedCategory() {
      return this.historicIndentsMenu.find(menu => menu.id === 'Historic Indent');
    },
  },

  created() {
    this.indentStatusList =  this.indentsStatus.filter(status => {
      if(status.feature) {
        return this.$hasFeature(status.feature);
      }
      return true;
    });
    // PAN-41564: align with shipper when the feature is ON (see modules/indents/index.vue).
    if (this.$hasFeature('transporter_delivery_pending_status')) {
      this.indentStatusList = this.indentStatusList.map(status =>
        (status.status_id === 23
          ? { ...status, name: 'Delivery Pending', tlabel: 'INDENT_DELIVERY_PENDING_STATUS' }
          : status));
      const deliveryPendingIdx = this.indentStatusList.findIndex(s => s.status_id === 23);
      if (deliveryPendingIdx !== -1 && !this.indentStatusList.some(s => s.status_id === 7)) {
        this.indentStatusList.splice(deliveryPendingIdx, 0, {
          id: 7, status_id: 7, name: 'Delivered', color: 'green', tlabel: 'INDENT_DELIVERED_STATUS',
        });
      }
    }
    this.setDefaults();
    this.loadFilters();
    this.$store.commit('indents/initialReset');
    this.loadSearchFromSession();
    this.search();
  },
  methods: {
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = Object.assign({}, this.searchedParams, sessionSearchParams);
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    setDefaults() {
      this.currentDepotId = this.depots[0];
      this.defaultValues.depot = [];
      this.defaultValues.depot.push(this.depots[0]);
      this.defaultValues.status = this.indentStatusList[23];
    },
    constructConstantForFilter() {
      this.filterConstant = [
        [
          {
            type: 'MultiSelectList',
            category: this.filters.DEPOT,
            tlabel: 'INDENT_DEPOT',
            default: this.defaultValues.depot,
            selected: this.defaultValues.depot,
            list: this.depots,
            idLabel: 'id',
            optional: false,
            allowEmpty: false,
            selectAllOption: true,
            queryParamString: 'depot_ids',
            placeholder: 'Select depots',
            search: true,
          },
        ],
        [
          {
            type: 'Date',
            category: this.filters.DATE,
            tlabel: 'INDENT_DATE',
            defaultStartDate: this.defaultValues.startDate,
            defaultEndDate: this.defaultValues.endDate,
            startDate: this.defaultValues.startDate,
            endDate: this.defaultValues.endDate,
            optional: true,
            start_date_label: 'start',
            end_date_label: 'end',
          },
        ],
      ];
    },
    resetApply() {
      this.$store.commit('indents/resetParentList');
      this.$store.commit('indents/setPage', 1);
      this.resetAll();
      this.search();
    },
    search() {
      this.$store.commit('indents/resetParentList');
      this.$store.commit('indents/setPage', 1);
      this.applyFilters();
      this.openSlideleft = false;
      this.loadData();
    },
    searchByParameter(params) {
      this.searchedParams = params;
      this.$store.commit('indents/resetParentList');
      this.$store.commit('indents/setPage', 1);
      this.saveSearchToSession();
      this.loadData();
    },
    async loadData() {
      try {
        if (this.depots && this.depots.length > 0) {
          let filter = this.constructFilterPayload();
          if (filter) {
            filter = Object.assign(filter, this.filter);
            if (this.searchedParams && Object.keys(this.searchedParams).length) {
              Object.assign(filter, { ...this.searchedParams });
            }
            if (!filter.status) {
              filter.status = [this.$statusUtil.getStatusId('delivered')];
              filter.show_delivered = this.includeDeliverStatus;
            } else {
              filter.status = [filter.status];
            }
            this.currentDepotId = filter.depot_id;
            const result = await this.$store.dispatch('indents/filter', filter);
            if (result.error) {
              this.$errorMessage({ message: result.error });
            }
            this.loadCheck = this.hasEmpty;
          }
        } else {
          this.$errorMessage({ message: this.$getErr('FEILDS_MISSING') });
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    openSlider(tab) {
      this.isDetailsEnabled = true;
      this.activeTab = tab;
    },
    closeSlider() {
      this.isDetailsEnabled = false;
    },
    async setSelectedIndent(orderNo, tab, isReturnIndent, hasChildIndents, action) {
      try {
        const result = await this.$store.dispatch('indents/getIndentDetails', { orderNo });
        if (result.data) {
          this.selectedIndent = result.data;
          this.selectedIndent.isReturnIndent = isReturnIndent;
          this.selectedIndent.isRoundTrip = !!hasChildIndents;
          this.action = action;
          this.openSlider(tab);
        }
        return result;
      } catch (error) {
        return error;
      }
    },
    showDetails(orderNo, isReturnIndent, hasChildIndents) {
      this.setSelectedIndent(orderNo, 'details', isReturnIndent, hasChildIndents);
    },
    showActions(orderNo, isReturnIndent, hasChildIndents, action) {
      this.setSelectedIndent(orderNo, 'actions', isReturnIndent, hasChildIndents, action);
    },
    async updateLR(data) {
      try {
        const result = await this.$store.dispatch('indents/updateLR', {
          orderNo: this.selectedIndent.order_no, data });
        if (result.data) {
          this.$successMessage({ message: this.$t('INDENT_LR_NUMBER_TOAST_MSG') });
          this.closeSlider();
        }
        return result;
      } catch (error) {
        return error;
      }
    },
    setGA(name, action, label) {
      const depot = this.findByCategory(this.filters.DEPOT) || {};
      this.$addGAEvent('Transporter - Indent Management', action, `Transporter ${name}:${label}`,
        depot.name);
    },
  },
};
</script>
